import React from 'react';
import CommonEpicLinkField from '@atlassian/jira-issue-create-commons/src/ui/epic-link-field/index.tsx';
import type { Props } from './types.tsx';

export const EpicLinkField = (props: Props) => {
	const { useFormContext, ...commonEpicLinkFieldProps } = props;
	// eslint-disable-next-line react-hooks/react-compiler
	const [, { setIsEpicLinkSelected }] = useFormContext();
	return (
		<CommonEpicLinkField
			{...commonEpicLinkFieldProps}
			setIsEpicLinkSelected={setIsEpicLinkSelected}
		/>
	);
};
